import { FC } from "react";
import { CartItem as TCartItem } from "../@types";
import { formatAsMoney } from "../helpers/numbers";
import { Link } from "react-router-dom";

const OrderSummaryItem: FC<{ item: TCartItem }> = ({ item }) => {
  return (
    <div className="flex gap-3 w-full">
      {item.product?.images?.length > 0 && (
        <Link to={`/marketplace/products/${item.product.id}`}>
          <img
            src={item.product.images[0].path}
            alt=""
            className="w-20 aspect-square rounded-md border"
          />
        </Link>
      )}
      <div className="flex flex-col flex-1 justify-between">
        <Link
          to={`/marketplace/products/${item.product.id}`}
          className="font-medium line-clamp-1 "
        >
          {item.product.name}
        </Link>
        <div className="font-medium">
          ₦ {formatAsMoney(item.product.price || 0)}
        </div>
        <div className="flex-1" />
        <div>x{item.quantity}</div>
      </div>
    </div>
  );
};

export default OrderSummaryItem;
